import $ from 'jquery';
import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./kpicell-options.html';
import _ from 'lodash';
import DataProvider from '../../../app/data-framework/data-provider';
import PermissionService from '../../../services/permission.service';
import LoginService from "../../../services/login.service";

    function KPICellOptions(params) {
        var self = this;

        self.dataProvider = DataProvider.getInstance();
        self.permissionService = new PermissionService(LoginService.userObject);

        self.params = params.widgetParams;
        self.widgetSignals = params.widgetSignals;
        self.id = params.id;
        self.validationMessage = ko.observable(null);
        self.subscriptions = [];

        self.options = self.params.observableOptions();

        self.metadata = self.dataProvider.getFlexPanelMetaDataObservable();
        self.observableOptions = self.params.observableOptions;

        self.subscriptions = [];
        self.loadMode = true;

        self.kpiColumns = ko.observableArray();
        self.displayedKpis = ko.observableArray();
        self.selectedKpi = ko.observable();
        self.categories = ko.observableArray();
        self.selectedCategory = ko.observable();

        self.fillPanelOptions();

        self.saveOptions = function() {
            var selectedOptions = self.observableOptions();

            selectedOptions.selectedCategory = [self.selectedCategory()];
            selectedOptions.selectedKPIColumnNames = [self.selectedKpi()];

            self.params.observableOptions(selectedOptions);

            self.widgetSignals().optionsPanelApply.dispatch();
        };

        self.cancel = function(data, element) {
            self.widgetSignals().optionsPanelClose.dispatch();
        };

        self.resetOptions = function () {
            self.selectedCategory(self.categories()[0]);
            self.selectedKpi('');
        };

        //subscriptions
        self.subscriptions.push(self.selectedCategory.subscribe(function(selectedCategory) {
            if (self.loadMode) {
                return;
            }

            self.setKpisByCategory(selectedCategory);
        }));

        self.subscriptions.push(self.metadata.subscribe(self.fillPanelOptions.bind(self)));

        self.widgetSignals().optionsPanelOpen.add(function() {
            self.loadMode = true;

            return self.fillPanelOptions();
        });

        self.widgetSignals().optionsPanelClose.add(function() {
            self.loadMode = true;
            self.fillPanelOptions();
        });

    }

    KPICellOptions.prototype.setPreviouslySelected = function() {
        var self = this;

        if (!_.isEmpty(savedCategory)) {
            self.selectedCategory(savedCategory);
        }

        if (!_.isEmpty(savedKpi)) {
            self.selectedKpi(savedKpi);
        }

        self.loadMode = false;
    };

    KPICellOptions.prototype.fillPanelOptions = function() {
        var self = this;

        var metadata = self.metadata && self.metadata().Table ? self.metadata().Table : null;

        if (!metadata) {
            return;
        }

        var savedKpi = _.get(self.options, 'selectedKPIColumnNames[0]', null);

        var kpis = _.filter(metadata, ['dashboardKPIFlag', 1]);
        self.kpiColumns(kpis);

        if (!_.isEmpty(savedKpi)) {
            self.selectedKpi(savedKpi);
        }

        self.categories(getUniqCategoriesWithKpis(self.metadata().Categories, kpis));

        var selectedCategory = !_.isEmpty(self.selectedKpi()) ? getKpiCategory(self.kpiColumns(), self.selectedKpi()) : self.categories()[0];
        self.selectedCategory((selectedCategory));

        self.setKpisByCategory(self.selectedCategory());

        self.loadMode = false;
    };

    function getUniqCategoriesWithKpis(categories, kpis) {
        var categoriesWithKpi = _.chain(kpis).uniqBy('categoryKey').map('categoryKey').value();

        return _.filter(categories, function(category) {
            return _.includes(categoriesWithKpi, category.categoryKey);
        });
    }

    KPICellOptions.prototype.setKpisByCategory = function(category) {
        if (!category) {
            return;
        }

        category = category.categoryKey || category;

        if (category === 'All') {
            return this.displayedKpis(this.kpiColumns());
        }

        var kpis = _.filter(this.kpiColumns(), ['categoryKey', category]);

        this.displayedKpis(kpis);
    };

    function getKpiCategory(kpis, selectedKpiKey) {
        var kpi = _.find(kpis, ['columnKey', selectedKpiKey]);

        return _.get(kpi, 'categoryKey', null);
    }

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    KPICellOptions.prototype.dispose = function() {

        var self = this;

        self.subscriptions.forEach(function(sub) {
            sub.dispose();
        });

    };

    export default {
        viewModel: KPICellOptions,
        template: templateMarkup
    };
